import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import {
  LeftOutlined,
  LoadingOutlined,
  RightCircleOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Space,
  PageHeader,
  Row,
  Col,
  Button,
  Menu,
  Divider,
  Checkbox,
  Collapse,
} from "antd";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PosService from "../../../services/PosService";
import { Card, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import MenuService from "../../../services/MenuService";
import OrderButton from "../../../components/OrderButton";
import menuLogo from "../../../assets/images/posmenu.svg";
import { useLocation } from "react-router-dom";
import { Grid } from "antd";
import { Badge } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { MenuOutlined } from "@ant-design/icons";
import PosCart from "./PosCart";
import RatingLayout from "../../../components/Layout/RatingLayout";
import { getColor } from "../../../utils";
import MenuDetail from "./MenuDetail";
const { useBreakpoint } = Grid;

const { Content, Sider } = Layout;
const { Panel } = Collapse;

const { Title, Text } = Typography;
const { SubMenu } = Menu;

const ServerMenus = (props) => {
  const [loading, setLoading] = useState(true);
  const [menus, setMenus] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const history = useHistory();
  const [type, setType] = useState("new");
  const [isPlaceorderSelected, setIsPlaceorderSelected] = useState(false);
  const [viewCartSelectes, setViewCartSeletion] = useState(false)
  const [selectedLeftMenu, setSelectedLeftMenu] = useState();
  const screens = useBreakpoint();

  const [cartData, setCartData] = useState();
  const [openDetail,setOpenDetails] = useState(false);
  const [selectedMenu,setSelectedMenu] = useState()

  const [data, setData] = useState([]);

  const [menudata, setMenuData] = useState([
  ]);

  const { search } = useLocation();
  useEffect(() => {
    (async () => {
      const id = new URLSearchParams(search).get("id");

      const data = await MenuService.getMenu(id);
      setData(data.menu_groups);
      setMenus(data.menu_groups);
      const menu = data?.menu_groups.map((val) => {
        return {
          path: "/",
          label: val.name,
          side_menu: true,
          value: val.id,
        };
      });
      setRoute(menu);
      //  setMenus(data.menu_groups);
      setLoading(false);
      getCarts();

      //  const statusItem = await PosService.getPosCartStatus(props.adminRestaurant,529)
    })();
  }, []);

  const getCarts = async () => {
    const cartdatas = await PosService.getPosCart(
      props.adminRestaurant,
      localStorage.getItem("tableId") && Number(localStorage.getItem("tableId"))
    );
    if (cartdatas && cartdatas?.cart_items?.length > 0) {
      setCartData(cartdatas);
      setCartItems(
        cartdatas?.cart_items
          ?.filter((item) => item.cart_item_status == "NEW")
          .map((item) => {
            return { ...item, count: item.quantity };
          })
          .filter((item) => item.quantity != 0)
      );
      setMenuData(
        cartdatas?.cart_items?.filter(
          (item) =>
            item.cart_item_status == "PREPARING" ||
            item.cart_item_status == "SERVED"
        )
      );
    }
  };

  const inputRefs = useRef([]);
  useEffect(() => {
    if (selectedLeftMenu) {
      const element = inputRefs.current[selectedLeftMenu];
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
      // inputRefs.current[selectedLeftMenu].scrollIntoView({
      //   behavior: "smooth",
      //   block: "start",
      // });
      // setData(menus.filter(item=>item.id === selectedLeftMenu))
    }
  }, [selectedLeftMenu]);

  const [route, setRoute] = useState([]);

  

  const addtoCart = async (menuItem) => {
    if (cartItems.find((item) => item.id === menuItem.id)) {
      const cart = cartItems.map((item) => {
        if (item.id === menuItem.id)
          return {
            ...item,
            count: item.count ? item.count + 1 : 1,
          };
        else return item;
      });
      setCartItems(cart);
      localStorage.getItem("serverId");
      localStorage.getItem("tableId");
      const payload = {
        table_id:
          localStorage.getItem("tableId") &&
          Number(localStorage.getItem("tableId")),
        // employee_id : localStorage.getItem("serverId") && Number(localStorage.getItem("serverId")),
        items: cart.map((item) => {
          return {
            menu_item_id: item.id,
            quantity: item.count ? item.count : 1,
          };
        }),
      };
      await PosService.addToCart(props.adminRestaurant, payload);
      getCarts();
    } else {
      setCartItems([...cartItems, menuItem]);
      const payload = {
        table_id:
          localStorage.getItem("tableId") &&
          Number(localStorage.getItem("tableId")),
        // employee_id : localStorage.getItem("serverId") && Number(localStorage.getItem("serverId")),
        items: [...cartItems, menuItem].map((item) => {
          return {
            menu_item_id: item.id,
            quantity: item.count ? item.count : 1,
          };
        }),
      };
      await PosService.addToCart(props.adminRestaurant, payload);
      getCarts();
    }
  };

  const addCount = async (menuItem, isAdd) => {
    if (isAdd) {
      const cart = cartItems.map((item) => {
        if (item.id === menuItem.id)
          return {
            ...item,
            count: item.count + 1,
          };
        else return item;
      });
      setCartItems(cart);
      const payload = {
        table_id:
          localStorage.getItem("tableId") &&
          Number(localStorage.getItem("tableId")),
        // employee_id : localStorage.getItem("serverId") && Number(localStorage.getItem("serverId")),
        items: cart.map((item) => {
          return {
            menu_item_id: item.id,
            quantity: item.count,
          };
        }),
      };
      await PosService.addToCart(props.adminRestaurant, payload);
    } else {
      const cart = cartItems.map((item) => {
        if (item.id === menuItem.id)
          return {
            ...item,
            count: item.count - 1,
          };
        else return item;
      });
      setCartItems(cart.filter((item) => item.count != 0));
      const payload = {
        table_id:
          localStorage.getItem("tableId") &&
          Number(localStorage.getItem("tableId")),
        // employee_id : localStorage.getItem("serverId") && Number(localStorage.getItem("serverId")),
        items: cart.map((item) => {
          return {
            menu_item_id: item.id,
            quantity: item.count,
          };
        }),
      };
      await PosService.addToCart(props.adminRestaurant, payload);
    }
  };

  const handleCheckboxChange = async (value, itemCart) => {
    const preparedData = menudata.map((item) =>
      item.id == itemCart.id ? { ...item, cart_item_status: "SERVED" } : item
    );
    setMenuData(preparedData);
    const payload = {
      // quantity: 7,
      // discount_id: null,
      cart_item_status: "SERVED",
      // kitchen_priority: "LOW",
      // is_sent_to_kitchen: true,
      // is_kitchen_acknowledged: true,
      // is_dispatched: true,
      // is_rejected: true
    };
    await PosService.posCartItemServed(
      props.adminRestaurant,
      itemCart.cart_item_id,
      payload
    );
  };

  const proccedToCheckout = async (typeOrder) => {
    if (typeOrder == "new") {
      if (cartItems.length > 0) {
        setIsPlaceorderSelected(true);
        setLoading(true);
        await PosService.posUpdateCart(cartItems[0].cart_id);
        setLoading(false);
        setType("prepare");
      }
    } else history.push(`/pos/checkout`);
  };

  
  return (
    <Layout style={{ padding: "0" }}>
      {screens.md && (
        <Sider width={200} collapsible className="app-sider ">
          <div>
            <img src={menuLogo} />
            <span style={{ fontWeight: "bold" }}>Savage Burrito</span>
          </div>
          <hr></hr>
          <span className="categories">Categories</span>
          {route.length > 0 && (
            <Menu
              mode="inline"
              defaultSelectedKeys={["1"]}
              defaultOpenKeys={["sub1"]}
              style={{ borderRight: 0, height: "100vh" }}
            >
              {route
                .filter((r) => r.side_menu)
                .map((r, i) =>
                  r.SubMenu ? (
                    <SubMenu
                      icon={r.icon}
                      key={`menu${r.label}${i}`}
                      title={r.label}
                    >
                      {r.subMenus
                        .filter((r) => !r.hideSideMenu)
                        .map((item, i) => (
                          <Menu.Item
                            icon={item.icon}
                            key={`menu${item.label}${i}`}
                            onClick={() => setSelectedLeftMenu(r.id)}
                          >
                            <div>{item.label}</div>
                          </Menu.Item>
                        ))}
                    </SubMenu>
                  ) : (
                    <Menu.Item
                      icon={r.icon}
                      key={`menu${r.label}`}
                      className={"selected-left"}
                      onClick={() => setSelectedLeftMenu(r.value)}
                    >
                      {r.label}
                    </Menu.Item>
                  )
                )}
            </Menu>
          )}
        </Sider>
      )}
      {!screens.md && viewCartSelectes ?
      <PosCart cartData={cartData}
      cartItems={cartItems}
      addCount={addCount}
      menudata={menudata}
      handleCheckboxChange={handleCheckboxChange}
      type ={type} setType={setType}
      proccedToCheckout={proccedToCheckout}
      setViewCartSeletion={setViewCartSeletion}/>
      :
     
      <Layout>
        <Content
          className=""
          style={{
            padding: 10,
            margin: "8px 0px",
            minHeight: 280,
            position: "relative",
          }}
        >
          {loading ? (
            <LoadingOutlined style={{ fontSize: "30px" }} />
          ) : (
            <Space direction="vertical" style={{ width: "100%",marginBottom:"100px" }}>
              <div className="pos-table-header">
                <Button
                  style={{ fontSize: "22px", marginBottom: "10px" }}
                  icon={<LeftOutlined />}
                  type="text"
                  onClick={() =>
                    history.push(
                      `/pos/pos-table?id=${localStorage.getItem("LoginId")}`
                    )
                  }
                >
                  Table no :{localStorage.getItem("tableNumber")}
                </Button>
                {!screens.md && (
                  <Badge
                    count={cartData?.cart_items?.length ?? 0}
                    size="small"
                    offset={[6, -2]}
                    style={{
                      backgroundColor: "#CB324C",
                      color: "#fff",
                      minWidth: 13,
                      height: 13,
                      lineHeight: "13px",
                      fontSize: 10,
                      borderRadius: "50%",
                      padding: 0,
                    }}
                    onClick={()=> setViewCartSeletion(true)}
                  >
                    <ShoppingCartOutlined
                      style={{ fontSize: 22, color: "#CB324C" }}
                    />
                  </Badge>
                )}
              </div>
              {!screens.md && (
                <div style={{ textAlign: "start" }} className="flex">
                  <img src={menuLogo}  style={{width: screens.md ? "200px":"100px"}}/>
                  <div>
                  <span style={{ fontWeight: "bold" , fontSize:"16px"}}>Savage Burrito</span>
                  <div style={{width:"70px"}}>
                  <RatingLayout rating={5} color={getColor(5)} />
                  </div>
                  </div>
                </div>
              )}
              {screens.md && <PageHeader title="POS Server Menu" />}
              <hr></hr>
              {data.map((item) => (
  <Collapse
    key={item.id}
    bordered={false}
    defaultActiveKey={data.map(item => item.id)}
    expandIconPosition="end"
    className="menu-collapse-pos"
  >
    <Panel header={item.name} key={item.id} className="menu-panel">
      
      {/* 👇 REF HERE */}
      <div ref={(el) => (inputRefs.current[item.id] = el)} style={
        {marginTop:"15px"}
      }>
        <Row gutter={[16, 16]}>
          {item.menu_items.map((menuItem) => (
            <Col
              key={menuItem.id}
              className="gutter-row relative menu_cardmain"
            >
              <Card
                bordered={false}
                style={{ width: 200, borderRadius: 10 }}
                onClick={()=>{setOpenDetails(true);
                  setSelectedMenu(menuItem)
                }}
              >
                <img
                  src={menuItem.photo_url}
                  style={{
                    height: 160,
                    width: "100%",
                    borderRadius: 10,
                    objectFit: "cover",
                  }}
                />

                <div className="pos-menu-content">
                  <Title level={4}>{menuItem.name}</Title>

                  <div className="menu-name">
                    Spice level: {menuItem.spice_level}
                  </div>
                 <div className="price-and-add">
                  <div className="theme-red">$ {menuItem.price}</div>

                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => addtoCart(menuItem)}
                  >
                    <PlusOutlined />
                  </div>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Panel>
  </Collapse>
))}
            </Space>
          )}
        </Content>
        {screens.md && (
          <Sider
            width={300}
            style={{
              height: "90vh",
              // position: "fixed",
              right: 0,
              // top: "60px",
              bottom: 0,
            }}
          >
            <div className="cart-tab">
              <Button
                onClick={() => setType("new")}
                className={
                  type == "new" ? "active-cart-btn" : "default-cart-btn"
                }
              >
                New Orders
              </Button>
              <Button
                onClick={() => setType("prepare")}
                className={
                  type == "prepare" ? "active-cart-btn" : "default-cart-btn"
                }
              >
                Preparing
              </Button>
            </div>
            <div className="cart-item-button">
              {type === "new" ? (
                <div>
                  {cartItems
                    ?.filter((item) => item.cart_item_status == "NEW")
                    ?.map((itemcarts) => (
                      <div className="cart-sections" key={itemcarts.id}>
                        <div style={{ textAlign: "left" }}>
                          <Title level={5}>{itemcarts.name}</Title>
                          <Text type="secondary">{itemcarts.description}</Text>
                          <div className="price-count">
                            <div className="theme-red cart-price">
                              $ {itemcarts.price}
                            </div>
                            <div>
                              <OrderButton
                                count={itemcarts.count ? itemcarts.count : 1}
                                increment={() => addCount(itemcarts, true)}
                                decrement={() => addCount(itemcarts, false)}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider style={{ margin: 0 }} />
                      </div>
                    ))}
                </div>
              ) : (
                <div>
                  {menudata?.map((value) => (
                    <div className="cart-sections">
                      <div
                        style={{
                          textAlign: "left",
                          background:
                            value.cart_item_status == "SERVED"
                              ? "#D2FFD1"
                              : "#FFF8D1",
                        }}
                      >
                        <div style={{ margin: "0 10px" }}>
                          <Title level={5}>{value.name}</Title>
                          <Text type="secondary">{value.description}</Text>
                          <div className="price-count">
                            <div className="theme-red">${value.price}</div>
                            <div>
                               {value.cart_item_status == "SERVED" ? "Served" : "Mark as Served"}{" "}
                              <Checkbox
                                className="served served-checkbox"
                                checked={value.cart_item_status == "SERVED"}
                                onChange={(e) =>
                                  value.cart_item_status !== "SERVED" &&
                                  handleCheckboxChange(e.target.checked, value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <Divider style={{ margin: 0 }} />
                    </div>
                  ))}
                </div>
              )}
              <div>
                <hr></hr>
                <Button
                  htmlType="submit"
                  style={{
                    display: "flex",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  className="mt-1"
                  type="primary"
                  onClick={() => proccedToCheckout(type)}
                  disabled={
                    (type == "prepare" &&
                      !isPlaceorderSelected &&
                      menudata.length == 0) ||
                    (type == "new" && cartItems.length == 0)
                  }
                >
                  {type === "new" ? "Place order" : "Proceed to Checkout"}
                </Button>
              </div>
            </div>
          </Sider>
        )}

{!screens.md &&
        <div className="bottom-fixed-wrapper">
          {/* Top Menu Section */}
          <div className="menu-bar-pos">
            <div className="menu-scroll">
              {route
                .filter((r) => r.side_menu)
                .map((r, i) => (
                  <div
                    key={r.value}
                    className={`menu-item ${
                      selectedLeftMenu === r.value ? "active-pos" : ""
                    }`}
                    onClick={() => setSelectedLeftMenu(r.value)}
                  >
                    {r.label}
                  </div>
                ))}
            </div>

            <div
              className="menu-action"
              onClick={() => history.push(`/pos/posmenu`)}
            >
              <MenuOutlined />
              <span>Menu</span>
            </div>
          </div>

          {/* Cart Section */}
          <div className="cart-bar">
            <div className="cart-left">
              <span className="items">
                {cartData?.cart_items?.length} Items
              </span>
              <span className="price mobile-price">${cartData?.price ?? 0}</span>
            </div>

            <div className="cart-right" onClick={()=> setViewCartSeletion(true)}>
              <span>View Cart</span>
              <RightCircleOutlined />
            </div>
          </div>
        </div>
}

<MenuDetail open ={openDetail}
selectedMenu={selectedMenu}
addtoCart = {addtoCart}
onClose ={setOpenDetails}/>

      </Layout>
       }
      
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};

export default withRouter(connect(mapStateToProps)(ServerMenus));
